import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-movie-2-line",
    label: "电影",
    desc: "院线大片与口碑佳作",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    label: "电视剧",
    desc: "热播剧集与经典长剧",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    label: "资讯",
    desc: "最新影视动态与报道",
  },
  {
    to: "/category/all",
    icon: "ri-compass-3-line",
    label: "全部影视",
    desc: "按条件自由筛选查找",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
      {entries.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-4 transition-all duration-200 hover:-translate-y-1 hover:border-primary-300 hover:bg-background-50"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${item.icon} text-2xl`} />
          </span>
          <span className="flex min-w-0 flex-col">
            <span className="text-sm font-semibold text-foreground-950">{item.label}</span>
            <span className="truncate text-xs text-foreground-500">{item.desc}</span>
          </span>
        </Link>
      ))}
    </div>
  );
}